import React from "react";

interface Props {
  enableAnimations: boolean;
  isInternalView: boolean;
  setInternalView: (value: boolean) => void;
}

const SidebarView: React.FC<Props> = ({ enableAnimations, isInternalView, setInternalView }) => {
  
  return (
    <div className="studio-sidebar-view">

      <div className={`studio-sidebar-view-button-container ${!isInternalView ? 'selected':''}`} onClick={() => {if(enableAnimations) setInternalView(false)}}>
        <div className={`studio-sidebar-view-button ${!isInternalView ? 'selected':''}`}>
          <div className={`studio-sidebar-view-text ${!isInternalView ? 'selected':''}`}>Diseño exterior</div>
        </div>
      </div>

      <div className={`studio-sidebar-view-button-container ${isInternalView ? 'selected':''}`} onClick={() => {if(enableAnimations) setInternalView(true)}}>
        <div className={`studio-sidebar-view-button ${isInternalView ? 'selected':''}`}>
          <div className={`studio-sidebar-view-text ${isInternalView ? 'selected':''}`}>Diseño interior</div>
        </div>
      </div>

    </div>
  );
};

export default SidebarView;